/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchRunResultCompanySettlementsInner
 */
export interface BatchRunResultCompanySettlementsInner {
    /**
     * company_settlement のUUID（明細集計行の識別子）。
     * 
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    companySettlementUuid: string;
    /**
     * 会社コード。
     * 精算書の発行単位・CSVのキー。
     * 
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    companyId: string;
    /**
     * 会社名
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    companyName: string;
    /**
     * ペイメントグループID。
     * 
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    paymentGroupId: string;
    /**
     * 納品番号
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    deliveryNo: string;
    /**
     * 対象サービスID
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    serviceId: string;
    /**
     * 費目名（コード値）。
     * 
     * 想定値:
     *   - TAXIFARE
     *   - TIP
     *   - CANCELREFUND1
     *   - ROAMINGSERVICEFEE
     * 
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    itemLabel: string;
    /**
     * 税区分
     * @type {number}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    taxKind: BatchRunResultCompanySettlementsInnerTaxKindEnum;
    /**
     * 黒赤区分
     * @type {number}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    debitCreditKind: BatchRunResultCompanySettlementsInnerDebitCreditKindEnum;
    /**
     * 会社単位の支払額
     * @type {number}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    subtotalAmount: number;
    /**
     * PDF用の名前
     * @type {string}
     * @memberof BatchRunResultCompanySettlementsInner
     */
    pdfName: string;
}


/**
 * @export
 */
export const BatchRunResultCompanySettlementsInnerTaxKindEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type BatchRunResultCompanySettlementsInnerTaxKindEnum = typeof BatchRunResultCompanySettlementsInnerTaxKindEnum[keyof typeof BatchRunResultCompanySettlementsInnerTaxKindEnum];

/**
 * @export
 */
export const BatchRunResultCompanySettlementsInnerDebitCreditKindEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type BatchRunResultCompanySettlementsInnerDebitCreditKindEnum = typeof BatchRunResultCompanySettlementsInnerDebitCreditKindEnum[keyof typeof BatchRunResultCompanySettlementsInnerDebitCreditKindEnum];


/**
 * Check if a given object implements the BatchRunResultCompanySettlementsInner interface.
 */
export function instanceOfBatchRunResultCompanySettlementsInner(value: object): value is BatchRunResultCompanySettlementsInner {
    if (!('companySettlementUuid' in value) || value['companySettlementUuid'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('paymentGroupId' in value) || value['paymentGroupId'] === undefined) return false;
    if (!('deliveryNo' in value) || value['deliveryNo'] === undefined) return false;
    if (!('serviceId' in value) || value['serviceId'] === undefined) return false;
    if (!('itemLabel' in value) || value['itemLabel'] === undefined) return false;
    if (!('taxKind' in value) || value['taxKind'] === undefined) return false;
    if (!('debitCreditKind' in value) || value['debitCreditKind'] === undefined) return false;
    if (!('subtotalAmount' in value) || value['subtotalAmount'] === undefined) return false;
    if (!('pdfName' in value) || value['pdfName'] === undefined) return false;
    return true;
}

export function BatchRunResultCompanySettlementsInnerFromJSON(json: any): BatchRunResultCompanySettlementsInner {
    return BatchRunResultCompanySettlementsInnerFromJSONTyped(json, false);
}

export function BatchRunResultCompanySettlementsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultCompanySettlementsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'companySettlementUuid': json['company_settlement_uuid'],
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'paymentGroupId': json['payment_group_id'],
        'deliveryNo': json['delivery_no'],
        'serviceId': json['service_id'],
        'itemLabel': json['item_label'],
        'taxKind': json['tax_kind'],
        'debitCreditKind': json['debit_credit_kind'],
        'subtotalAmount': json['subtotal_amount'],
        'pdfName': json['pdf_name'],
    };
}

export function BatchRunResultCompanySettlementsInnerToJSON(json: any): BatchRunResultCompanySettlementsInner {
    return BatchRunResultCompanySettlementsInnerToJSONTyped(json, false);
}

export function BatchRunResultCompanySettlementsInnerToJSONTyped(value?: BatchRunResultCompanySettlementsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_settlement_uuid': value['companySettlementUuid'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'payment_group_id': value['paymentGroupId'],
        'delivery_no': value['deliveryNo'],
        'service_id': value['serviceId'],
        'item_label': value['itemLabel'],
        'tax_kind': value['taxKind'],
        'debit_credit_kind': value['debitCreditKind'],
        'subtotal_amount': value['subtotalAmount'],
        'pdf_name': value['pdfName'],
    };
}

